import React from 'react';
import Header from './Header';
import { BroadcastBanner } from './Header';
import BottomNav from './BottomNav';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-[#f8f7fb]">
      <Header />
      <BroadcastBanner />
      <main className="max-w-7xl mx-auto page-content">
        {children}
      </main>
      <BottomNav />
    </div>
  );
}
